<template>
  <div class="tab-content">
    <component :is="activeSection"></component>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Charts from './TrendingCharts.vue';
  import Performance from './PerformanceEvaluation.vue';
  import Tracking from './TrackingSheet.vue';

  export default {
    name: 'ContentBody',
    components: {
      Charts,
      Performance,
      Tracking,
    },
    computed: {
      ...mapGetters('allergyKpis', ['activeSection']),
    },
  }
</script>
